import React, { Component } from "react";
import axios from "axios";
import { datahost } from "../../config/Const.js";
import { replaceAllFixed } from "../../function/Basic.js";

export class WalkScore extends Component {
  static displayName = WalkScore.name;

  constructor(props) {
    super(props);
    this.state = {
      wskey: null,
    };
  }

  componentDidMount() {
    this.createWalkScore();

    // setTimeout(function () {
    //   // let footer = document.getElementById("ws-footer");
    //   // if (footer !== null) {
    //   //   footer.remove();
    //   // }
    //   let test = document.getElementById("ws-walkscore-tile");
    //   test.scroll = "no";
    // }, 3000);

    // window.οnlοad = function () {
    //   let footer = document.getElementById("ws-footer");
    //   if (footer !== null) {
    //     footer.remove();
    //   }
    // };
  }

  render() {
    return (
      <div>
        <div id="ws-walkscore-tile"></div>
      </div>
    );
  }

  importWalkSchoolJS() {
    let script = document.querySelector("#script");
    if (script) {
      return;
    }
    script = document.createElement("script");
    script.id = "script_import";
    script.src = "https://www.walkscore.com/tile/show-walkscore-tile.php";
    document.querySelector("body").appendChild(script);
  }

  removeFooter() {
    let footer = document.getElementById("ws-footer");
    if (footer !== null) {
      footer.remove();
    }
  }

  async createWalkScore() {
    var url = document.location.toString();
    let paras = url.split("?").splice(1, 1)[0].split("#")[0].split("=");
    if (paras.length < 2) {
      return;
    }
    let tk = paras[0];
    let tmpparas1 = replaceAllFixed(paras[1], "~", "=");
    let address = window.atob(tmpparas1);
    let style = "tall";
    let width = window.screen.width * 0.9;
    let height = width * 1.5;

    axios.defaults.baseURL = datahost;
    axios.defaults.headers.post["Content-Type"] = "application/json";

    let param = "\"{'tk':'" + tk + "'}\"";
    axios.post("/detail/walkscore", param).then((res) => {
      this.setState({
        wskey: res.data,
      });
    });

    const jsCode =
      "var ws_wsid = '" +
      this.state.wskey +
      "'; var ws_address = '" +
      address +
      "'; var ws_format = '" +
      style +
      "'; var ws_width = '" +
      width +
      "'; var ws_height = '" +
      height +
      "';";
    let script = document.querySelector("#script");
    if (script) {
      return;
    }
    script = document.createElement("script");
    script.id = "script_init";
    script.innerHTML = jsCode;
    document.querySelector("body").appendChild(script);

    this.importWalkSchoolJS();
  }
}
